<template>
  <b-container>
    <div style="margin-top: 200px" v-show="loading">
      <ring-loader></ring-loader>
      <h1>Cargando...</h1>
    </div>

    <b-row v-show="!loading">
      <b-col md="10" offset="1">

        <div class="alert alert-light shadow mt-5">
          <h4>Importante</h4>
          <p>Solo puedes ganar monedas si juegas desde la Android app. Tu participación por jugar aquí será registrada
            pero no podrás obtener monedas.</p>
        </div>

        <b-card class="my-5 shadow">
          <h3>Trivia Anime &#x1F3AF;</h3>
          <hr>
          <div class="text-left">
            <label style="display: block">Dificultad:</label>
            <b-button-group>
              <b-button :class="['btn-anime', difficulty === 'easy' ? 'chosen' : null]"
                        @click="difficulty = 'easy'" variant="outline-primary" class="btn-anime">Fácil
              </b-button>
              <b-button :class="['btn-anime', difficulty === 'medium' ? 'chosen' : null]"
                        @click="difficulty = 'medium'" variant="outline-primary" class="btn-anime">Medio
              </b-button>
              <b-button :class="['btn-anime', difficulty === 'hard' ? 'chosen' : null]"
                        @click="difficulty = 'hard'" variant="outline-primary" class="btn-anime">Experto
              </b-button>
            </b-button-group>
          </div>
          <br>
          <div>
            <label class="d-block text-left">Elige un Anime:</label>
            <ul class="list-group mt-1">
              <li class="list-group-item" v-for="anime in $store.getters.trivia_animes" :key="anime.id"
                  @click="participate(anime)">
                {{ anime.name }}
              </li>
            </ul>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {http} from "../../misc/http";
import {RingLoader} from 'vue-spinners-css';
import moment from "moment";

export default {
  name: "Index",
  components: {
    RingLoader,
  },
  data() {
    return {
      animes: [],
      difficulty: 'easy',
      loading: true,
    }
  },
  mounted() {
    this.getAnimesList();
  },
  methods: {
    async getAnimesList() {
      this.loading = true;

      await this.$store.dispatch('loadTriviaAnimes');

      const trivia_animes = this.$store.getters.trivia_animes;
      const trivia_expires_at = this.$store.getters.trivia_animes_expires_at;

      try {
        if (trivia_animes.length === 0 || (trivia_animes.length && moment().isAfter(trivia_expires_at))) {
          const response = await http.get('/trivia/animes');
          await this.$store.dispatch('setTriviaAnimes', response.data.animes);
        }

        this.loading = false;
      } catch (error) {
        //console.log(error);
        this.loading = false;
      }
    },
    participate(anime) {
      this.$router.push(`/trivia/participate/${anime.id}?mode=${this.difficulty}`);
    },
  }
}
</script>

<style scoped>
.list-group-item:hover {
  background: #673bb7;
  color: snow;
  font-weight: bold;
  cursor: pointer;
}

.btn-anime {
  border-color: #673bb7;
  color: #673bb7;
}

.btn-anime:hover {
  background: #673bb7 !important;
  border-color: #673bb7 !important;
  color: snow;
}

.chosen {
  background: #673bb7;
  color: snow;
  font-weight: bold;
}
</style>